<template>
	<div class="content_box">
		<div class="title">
			<span class="left_shu"></span>
			车辆状态
		</div>
		<div class="content_information">
			<div class="content_left">
				<div class="information_title">
					基本参数
				</div>
				<div class="information_text">
					车型名称:B1B-A-113<br />
					车身尺寸(长*宽*高):1982x1065x1758mm<br />
					货箱尺寸(长*宽*高):1200x1000x900mm<br />
					整车重量:550kg<br />
					最大载重:250kg<br />
					最大速度:25km/h<br />
					最大爬坡:20%<br />
					电池总容量:100Ah<br />
					额定功率:3500W<br />
					峰值功率:8750W<br />
					最大涉水深度:100mm
				</div>
				<div class="information_title">
					运行参数
				</div>
				<div class="information_text">
					行驶状态：{{car.taskState==0?'空闲':'行驶中'}}<br />
					车速：{{car.speed}}km/h<br />
					纬度：{{car.latitude}}<br />
					经度：{{car.longitude}}<br />
					充电状态：{{battery.chargingFlag==0?'未充电':'充电中'}}<br />
					续航里程：{{battery.endurance}}<br />
					剩余电量：{{battery.residualFuel}}<br />
				</div>
			</div>
			<div class="content_right">
				<img src="../../assets/image/car.png" style="width: 600px;">
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data(){
			return{
				car:{//车辆信息
					altitude:'东',//方向
					azimuth:0,//车头朝向
					driveMode:'',//驾驶模式
					latitude:0,//纬度
					longitude:0,//经度
					number:0,//车辆编号
					speed:0,//速度
					taskState:0,//任务状态
				},
				battery:{//电池信息
					ammeter:0,//电流
					chargingFlag:0,//是否正在充电
					endurance:0,//续航里程
					odometer:0,//累计里程
					residualFuel:0,//剩余电量
					temperature:0,//电池温度
					voltage:0,//电池电压
				},
			}
		},
		mounted(){
			this.getData()
		},
		created() {
			console.log(this.$route)
		},
		methods:{
			async getData() {
				let result = await this.request.post("/v1.0/car/getHomeData", {
					'deviceType':1
				});
				console.log(result.data)
				this.car = result.data.car
				this.battery = result.data.battery
			},
		}
	}
</script>

<style>
	@import url("../../assets/css/common.css");
	.content_information{
		display: flex;
		width: 100%;
	}
	.content_left{
		width: 40%;
	}
	.information_title{
		line-height: 44px;
		padding-left: 50px;
		color: #333333;
		font-size: 16px;
		background: linear-gradient(to right,#EBEBEB,#fafafa);
		font-weight: bold;
	}
	.information_text{
		padding: 20px 0 20px 50px;
		color: #666666;
		font-size: 14px;
		line-height:28px;
	}
	.content_right{
		margin-left: 100px;
		width: 60%;
	}
	
</style>
